<div class="functions-container">
  <div class="functions-container__search">
    <app-inventory-table-search
      [placeholder]="'inventory.placeholders.search' | translate"
      (searchInput)="onSearchInput($event)"
    />
  </div>

  <div class="functions-container__buttons">
    <button class="btn-white filter-button" (click)="openFilter()">
      @if (hasActiveFilters()) {
        <span class="filter-indicator"></span>
      } @else {
        <span class="icon-wrapper">
          <app-icon class="icon" [icon]="iconName.FILTER" />
        </span>
      }
      <span class="btn-text">{{ 'inventory.buttons.filter' | translate }}</span>
    </button>

    <button class="btn-white">
      <span class="icon-wrapper">
        <app-icon class="icon" [icon]="iconName.SCAN" />
      </span>
      <span class="btn-text">{{ 'inventory.buttons.scan' | translate }}</span>
    </button>

    <button class="btn-white" (click)="onExport()">
      <span class="icon-wrapper">
        <app-icon class="icon" [icon]="iconName.EXPORT" />
      </span>
      <span class="btn-text">{{ 'inventory.buttons.export' | translate }}</span>
    </button>

    <button class="btn-primary add-button" (click)="openAddInventoryItem()">
      <span class="icon-wrapper">
        <app-icon class="icon" [icon]="iconName.PLUS" />
      </span>
      <span class="btn-text">{{ 'inventory.buttons.addProduct' | translate }}</span>
    </button>
  </div>
</div>
<div class="functions-container__filters-flex">
    @for (key of activeFilterKeys(); track key) {
      <div class="functions-container__active-filter">
        <h6 class="functions-container__filter-title">{{ key }}:</h6>

        <p class="functions-container__filter-product">{{ activeFilters()[key] }}</p>

        <button class="functions-container__close-filter" (click)="removeFilter(key)">
          <app-icon class="filter-close-icon" [icon]="iconName.CLOSE_SM" />
        </button>
      </div>
    }

    @if (activeFilterKeys().length) {
      <button class="functions-container__reset-filters" (click)="onResetAll()">Reset all</button>
    }
</div>
